import { render, staticRenderFns } from "./AskMessage.vue?vue&type=template&id=46cc8710&scoped=true&"
import script from "./AskMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskMessage.vue?vue&type=style&index=0&id=46cc8710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc8710",
  null
  
)

export default component.exports